const Container = ({ children, className = "" }: any ) => {
  return (
    <div className={`max-w-[1217px] w-full mx-auto ${className}`}>
    {/* <div className={`relative z-20 max-w-[1217px] w-full mx-auto ${className}`}> */}

      {children}
    </div>
  );
};

export default Container;